import React from "react";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";
import Layout from "../../components/Layout.tsx";
import QrScanner from "./QrScanner.tsx";
import { useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";
import { useNavigate } from "react-router-dom";
import { can } from "../../auth/can.ts";

type Props = {};

const RelojChecador = (_props: Props) => {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  useAppSettings();

  if (!can("attendance.check", user)) {
    navigate("/");
    return null;
  }

  return (
    <Layout>
      <QrScanner />
    </Layout>
  );
};

export default RelojChecador;